import Heading from 'components/Basic/Heading/Heading';
import Image from 'components/Basic/Image/Image';
import LimitHeightWrap from 'components/Helpers/LimitHeightWrap/LimitHeightWrap';
import useTranslation from 'next-translate/useTranslation';
import React, { ReactNode } from 'react';

type CategoryHeaderProps = {
    title: string | null | undefined;
    description: string | null;
    slug: string;
    uuid: string;
    imageSrc: string | null;
    name: string;
    adverts?: ReactNode;
    currentPage: number;
};

export const CategoryHeader: FC<CategoryHeaderProps> = ({
    adverts,
    currentPage,
    description,
    slug,
    uuid,
    imageSrc,
    name,
    title,
}) => {
    const { t } = useTranslation();

    return (
        <div className="mb-10 flex w-full justify-between">
            <div className="max-w-[700px]">
                {adverts}
                <Heading type="h1">{title}</Heading>
                {description !== null && currentPage === 1 && (
                    <LimitHeightWrap
                        mobileHeight={120}
                        desktopHeight={120}
                        buttonLabelMore={t('Read more')}
                        buttonLabelLess={t('Read less')}
                        buttonAlign="left"
                        buttonVariant="link"
                        buttonClassName="pl-0"
                        updateDependency={slug}
                        isDefaultCollapsed
                    >
                        <section
                            className="user-text text-body leading-7 vl:text-h6 vl:leading-8"
                            dangerouslySetInnerHTML={{ __html: description }}
                        />
                    </LimitHeightWrap>
                )}
            </div>
            {imageSrc !== null && currentPage === 1 && (
                <div className="ml-20 hidden h-44 w-[418px] shrink-0 vl:block">
                    <Image
                        key={uuid}
                        src={imageSrc}
                        width="418"
                        height="176"
                        priority
                        alt={name}
                        className="max-h-full max-w-full"
                    />
                </div>
            )}
        </div>
    );
};
